import React, { useState } from 'react';
import ImageModal from '../../components/ImageModal';

const images = [
  '/images/funzo pictures/ab.jpg',
  '/images/funzo pictures/ag.jpg',
  '/images/funzo pictures/ak.jpg',
  '/images/funzo pictures/al.jpg',
  '/images/a.jpg',
  '/images/b.jpg',
  '/images/f.jpg',
  '/images/g.jpg',
  '/images/j.jpg',
  '/images/m.jpg',
  '/images/p.jpg',
  '/images/q.jpg',
];

const AlphabetGallery = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  const openModal = (index) => {
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const showNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <main id="alphabet-gallery" className="w-full relative z-10 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h1 className="font-serif text-4xl text-coffee-dark mb-8 text-center">Our Image Gallery</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-lg shadow-lg h-64 cursor-pointer"
              onClick={() => openModal(index)}
            >
              <img
                src={image}
                alt={`Gallery image ${index + 1}`}
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
      <ImageModal
        image={currentImageIndex !== null ? images[currentImageIndex] : null}
        onClose={closeModal}
        onNext={showNextImage}
        onPrev={showPrevImage}
      />
    </main>
  );
};

export default AlphabetGallery;
